// extracted by mini-css-extract-plugin
export var contentBody = "_bf-9";
export var headerImage = "_bf-2";
export var imageButton = "_bf-7";
export var imageButtonIcon = "_bf-8";
export var imageHeader = "_bf-4";
export var imageHeaderText = "_bf-5";
export var imageOverlay = "_bf-3";
export var imageTitle = "_bf-6";
export var imageWrapper = "_bf-1";
export var taskList = "_bf-a";
export var widget = "_bf-0";